<template>
  <div
    class="rounded-t bg-white mb-0 px-6 py-6 flex justify-between uppercase font-bold items-center"
  >
    <div class="flex w-full justify-between">
      <h3 class="ml-8">Notice Edit</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoticeEditPageHeader"
};
</script>
